module.exports = __webpack_public_path__ + "static/img/24.ff67b9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/24.jpg
// module id = OTyt
// module chunks = 1